import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../../components/Loader'

import { useContentQuestion } from '../../../hooks/Others/LearningAndDevelopment/useContentQuestion'
import AddQuiz from './AddQuiz'

export default function EditQuiz() {
  const { contentQuestion, getContentQuestion } = useContentQuestion()
  const params = useParams()
  useEffect(() => {
    getContentQuestion({ _id: params.contentQuestionId })
  }, [params.contentQuestionId])

  return <> {contentQuestion ? <AddQuiz quiz={contentQuestion} /> : <Loader />} </>
}